import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {AnimationContext} from "./AnimationContext";
import {SlideInAnimation} from "./SlideInAnimation";

export class DropAnimation extends SlideInAnimation {

    constructor() {
        super("down");
    }

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        const time = this.time || 0.4;
        this.time = 0.7 * time;
        this.ease = this.ease || "sineIn";
        super.animate(item, context, () => {
            item.tweenTo(time * 0.15, Ease.sineInOut, {
                scaleY: item.scaleY * 0.9,
                repeat: 1,
                yoyo: true,
                onUpdate: () => {
                    this.updatePaperCut(item);
                    this.onUpdate();
                },
                onComplete: cb,
            });
        });
    }
}
